/*
 * @Author: HGcth66 HGcth66@163.com
 * @Date: 2025-07-17 16:36:51
 * @LastEditors: HGcth66 HGcth66@163.com
 * @LastEditTime: 2025-10-14 13:38:22
 * @FilePath: \emercontrol_php\front\src\agent\websocket.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import io from 'socket.io-client';
import store from '../store/index';
import { ElMessage } from 'element-plus';
import { SceneDataProcessingMixin } from '../mixins/reloadPageData.js';
import { websocketResponseMixin } from '../mixins/websocketResponseMixin.js';

export const websocket = {
  connectSocket(websoketurl) {
    const socket = io(websoketurl);
    console.log('socket :>> ', socket);
    window.socket = socket;
    store.commit('setSocket', socket);
    let userinfo = window.localStorage.getItem('origin_userInfo');
    userinfo = JSON.parse(userinfo);
    console.log('userinfo :>> ', userinfo);
    socket.on('connect', () => {
      // 页面配置数据 场景列表 - 使用map方法更安全高效地生成页面数组
      const pages = Array.isArray(store.state.ProjectInfo?.SceneryList)
        ? store.state.ProjectInfo.SceneryList.filter(item => item && typeof item === 'object') // 过滤无效项
            .map(item => ({
              name: item.SceneName || '',
              code: item.id || '',
              description: item.SceneDesc || '',
              isChangeBk: item.isChangeBk || false,
              Background: item.Background || '',
            }))
        : [];

      console.log('生成的页面配置数据:', pages);
      // const pages =
      //   { name: '项目介绍', code: 'pandect', description: '景区游玩项目详情介绍' },
      //   {
      //     name: '数据总览',
      //     code: 'emer_infopublish',
      //     description:
      //       '园区的实时在园人数、园区检票量、园区售票额、游客省份归属地、游客年龄、商户消费排名的相关数据图表',
      //   },
      //   {
      //     name: '客流监测',
      //     code: 'passengerflow',
      //     description: '园区的年客流、月客流、日客流、区域客流、分段入园人数的相关数据图表',
      //   },
      //   {
      //     name: '停车数据',
      //     code: 'carflow',
      //     description:
      //       '园区的停车场统计、停车场收费按年统计、停车场收费按月统计、停车场收费按日统计的相关数据图表',
      //   },
      //   {
      //     name: '游客画像',
      //     code: 'portrait',
      //     description: '游客的归属省份、城市、年龄、性别、游玩偏好、有车比例的数据统计图表',
      //   },
      //   {
      //     name: '资源数据',
      //     code: 'resource',
      //     description: '园区的资源数据统计图表',
      //   },
      //   {
      //     name: '视频监控',
      //     code: 'video_monitoring',
      //     description: '园区的视频监控点位地图',
      //   },
      //   { name: '环境监测', code: 'environment_sanitation', description: '当日气象数据、周气象数据' },
      //   { name: '评论数据', code: 'comment', description: '园区评论按年、按月、按天数据统计图表' },
      //   {
      //     name: '营收数据',
      //     code: 'operate',
      //     description: '园区票务销售按年、按月、按天数、销售排名据统计图表',
      //   },
      //   { name: '热力数据', code: 'heatmap', description: '景区的人流量热力数据地图' },
      // ];

      // 生成简化的提示词结构
      let page_module = {
        // description: "所有页面都支持router跳转到对应页面。部分页面支持特定操作。做任何特定操作前，必须先使用router跳转到对应页面为前提操作",
        // commonAction: "router: 跳转页面 payload:{code:'页面code',type:'page_module'}",
      };
      let systemdata = {
        name: userinfo?.newName || '未知',
        userinfo: {
          destination_id: userinfo?.destination_id || '未知',
        },
        description:
          '这是' +
          (userinfo?.newName || '未知') +
          '，可进行路由页面跳转，页面交互和介绍功能，pages里是整个系统的页面相关数据，介绍整个系统需要按照pages里的数据进行相应的介绍',
        // pages: pages,
        pages: pages.map(page => ({
          name: page.name,
          code: page.code,
          description: page.description,
        })),
      };

      console.log('发送给服务器的系统数据:', systemdata);
      socket.emit('systemdata', systemdata);
    });
    socket.on('connect_error', err => {
      console.log('连接错误:', err);
    });

    // 恢复为麦克风模式，移除控制台命令相关功能
    socket.on('message', data => {
      console.log('收到 WebSocket 消息:', data);
      if (data.wait_id) {
        window.sessionStorage.setItem('wait_id', data.wait_id);
        window.sessionStorage.setItem('code', data.payload.code);
      }
      switch (data.action) {
        case 'router':
          const targetRouteId = data.payload.code;

          if (targetRouteId) {
            let currentSceneId = store.state.ProjectInfo.CurrentScene.id;

            // 查找当前场景项
            const currentScene =
              Array.isArray(store.state.ProjectInfo?.SceneryList) &&
              store.state.ProjectInfo.SceneryList.find(scene => scene?.id === targetRouteId);

            if (currentSceneId != targetRouteId) {
              store.commit('set_CurrentScene', targetRouteId);

              store.commit('setCurrentSceneId', targetRouteId);

              // 设置背景的辅助函数
              const setBackground = backgroundValue => {
                store.commit('set_ProjectBackground', backgroundValue);
                store.commit('set_CurrentConfigration', backgroundValue);
              };

              // 获取有效的背景默认值
              const getValidBackgroundDefault = () => {
                try {
                  const backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
                  // 检查背景默认值是否有效
                  if (
                    backgroundDefault &&
                    backgroundDefault !== 'null' &&
                    backgroundDefault !== 'undefined'
                  ) {
                    return backgroundDefault;
                  }
                } catch (error) {
                  console.error('解析背景默认值出错:', error);
                }
                return originalBackground;
              };

              // 根据场景配置设置背景
              if (currentScene && currentScene.isChangeBk) {
                if (currentScene.bagTitle === '图片背景') {
                  setBackground(getValidBackgroundDefault());
                } else if (currentScene.Background) {
                  setBackground(currentScene.Background);
                }
              } else {
                setBackground(getValidBackgroundDefault());
              }

              setTimeout(() => {
                ElMessage.success('AI正在为你处理，已成功跳转相应页面并请求数据');
              }, 500);
            } else {
              console.log('当前已在目标页面，检查是否需要发送数据');

              // 将currentScene传递到SceneDataProcessingMixin中处理
              let processedData = SceneDataProcessingMixin.processChartData(currentScene);
              websocketResponseMixin.sendAgentResponse(processedData);

              setTimeout(() => {
                window.this.$message.success('AI正在为你处理，数据已重新加载');
              }, 500);
            }
          }
          break;
        case 'chat_completed':
          console.log('AI 处理完成:', data.message);
          break;
        case 'chat_completed_with_card':
          console.log('AI 处理完成（含卡片）:', data.message);
          break;
        case 'query':
          // 检查目标页面是否已加载完成
          if (data.payload.type == 'setting_module') {
            window.this.$bus.$emit('query', data);
            return;
          }
          const checkPageReady = () => {
            const targetCode = data.payload.code;
            const isCurrentPage = store.state.ProjectInfo.CurrentScene.id === targetCode;
            // const isPageReady = window.pageLoadingStatus && window.pageLoadingStatus[targetCode];

            if (isCurrentPage) {
              window.this.$bus.$emit('query', data);
            } else {
              // 页面未准备好，延迟重试
              setTimeout(checkPageReady, 500);
            }
          };

          // 延迟执行，给页面跳转时间
          setTimeout(checkPageReady, 1500);
          break;
        default:
          console.log('未知消息类型:', data);
      }
    });

    socket.on('disconnect', () => {
      console.log('连接断开');
    });

    // 通用的数据反馈方法
    const sendAgentResponse = responseData => {
      const waitId = window.sessionStorage.getItem('wait_id');
      if (waitId && socket && socket.connected) {
        socket.emit('agent_response', {
          wait_id: waitId,
          response_data: responseData,
        });
        console.log('📤 已发送数据反馈给后端:', responseData);
        window.sessionStorage.removeItem('wait_id');
        window.sessionStorage.removeItem('code');
      } else if (!waitId) {
        console.log('ℹ️ 无需发送数据反馈（无wait_id）');
      } else {
        console.warn('⚠️ Socket未连接，无法发送数据反馈');
      }
    };

    // 将方法挂载到全局，供页面组件调用
    window.sendAgentResponse = sendAgentResponse;

    // 监听数字人完成消息
    window.addEventListener('message', event => {
      if (event.data && event.data.type === 'DIGITAL_HUMAN_COMPLETION') {
        console.log('📥 收到数字人完成消息:', event.data);

        // 检查socket连接状态
        if (socket && socket.connected) {
          // 通过socket发送完成消息给后端
          socket.emit('digitalhuman_completion', {
            wait_id: event.data.wait_id,
            completion_data: {
              duration: event.data.completion_data.duration,
              status: 'completed',
              message: '数字人讲话已完成',
            },
          });
          console.log('📤 已通过socket发送数字人完成消息给后端');
        } else {
          console.warn('⚠️ Socket未连接，无法发送数字人完成消息');
        }
      }
    });
  },
};
